/**
 * Pull human-readable messages out of express-validator `{ error, details }` payloads.
 */
export function getApiValidationMessage(data, fallback = 'Validation failed') {
  if (!data) return fallback;
  const details = data.details || data.errors;
  if (Array.isArray(details) && details.length > 0) {
    const messages = details
      .map((item) => item?.msg || item?.message)
      .filter(Boolean);
    if (messages.length) return [...new Set(messages)].join('. ');
  }
  return data.message || data.error || fallback;
}

export function getApiFieldErrors(data) {
  const details = data?.details || data?.errors;
  if (!Array.isArray(details)) return {};
  return details.reduce((acc, item) => {
    const field = item?.path || item?.param || item?.field;
    const message = item?.msg || item?.message;
    if (field && message) acc[field] = message;
    return acc;
  }, {});
}
